import { useState } from "react";
import { Play } from "lucide-react";
import heroStaircase from "@/assets/hero-staircase.jpg";
import ScrollReveal from "./ScrollReveal";

const VideoSection = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  
  // Facebook Reel embed URL
  const facebookVideoUrl = "https://www.facebook.com/reel/722073170165092";
  const embedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(facebookVideoUrl)}&show_text=false&width=560`;

  const handlePlayClick = () => {
    setIsVideoLoaded(true);
  };

  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4">
        <ScrollReveal>
          <div className="text-center mb-12">
            <h2 className="section-heading">Meet Big Bear's Pro Floors</h2>
            <p className="section-subheading mx-auto">
              See the craftsmanship behind every project.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2} direction="none">
          <div className="max-w-2xl mx-auto">
            {/* Video Container with Poster/Play Button */}
            <div className="relative rounded-lg overflow-hidden shadow-2xl bg-charcoal" style={{ paddingBottom: '177.78%' }}>
              {!isVideoLoaded ? (
                // Poster Image with Play Button
                <button
                  onClick={handlePlayClick}
                  className="absolute inset-0 w-full h-full cursor-pointer group"
                  aria-label="Play video"
                >
                  <img
                    src={heroStaircase}
                    alt="Big Bear's Pro Floors - Click to play video"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-charcoal/40 group-hover:bg-charcoal/30 transition-colors" />
                  {/* Play Button */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-20 h-20 md:w-24 md:h-24 bg-accent rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                      <Play className="w-8 h-8 md:w-10 md:h-10 text-accent-foreground ml-1" fill="currentColor" />
                    </div>
                  </div>
                  {/* Text overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-charcoal/80 to-transparent">
                    <p className="text-primary-foreground font-heading font-bold text-lg md:text-xl">
                      Watch Our Work
                    </p>
                  </div>
                </button>
              ) : (
                // Lazy-loaded Facebook Video Embed
                <iframe
                  src={embedUrl}
                  className="absolute inset-0 w-full h-full border-0"
                  style={{ border: 'none', overflow: 'hidden' }}
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  title="Big Bear's Pro Floors - Our Work"
                  loading="lazy"
                />
              )}
            </div>

            {/* Caption */}
            <p className="text-center mt-8 text-lg md:text-xl font-heading text-foreground">
              "Owner-operated craftsmanship. Real work. Real results."
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default VideoSection;
